// extracted by mini-css-extract-plugin
export var modal = "_sk-0";
export var table = "_sk-1";